import api from './client';

export async function getSubscription() {
  const { data } = await api.get('/api/v1/billing/subscription');
  return data;
}

export async function getUsage() {
  const { data } = await api.get('/api/v1/billing/usage');
  return data;
}

export async function getStripeConfig(): Promise<{ publishableKey: string }> {
  const { data } = await api.get('/api/v1/billing/config');
  return data;
}

export async function createPaymentIntent(plan: string) {
  const { data } = await api.post('/api/v1/billing/create-payment-intent', { plan });
  return data as { clientSecret: string; type: 'setup' | 'payment'; plan: string };
}

export async function confirmSubscription(plan: string, setupIntentId: string) {
  const { data } = await api.post('/api/v1/billing/confirm-subscription', { plan, setupIntentId });
  return data;
}

export async function confirmCredits(paymentIntentId: string, creditPack: string) {
  const { data } = await api.post('/api/v1/billing/confirm-credits', { paymentIntentId, creditPack });
  return data;
}

export async function openPortal() {
  const { data } = await api.post('/api/v1/billing/portal');
  return data;
}
